module.exports = __webpack_public_path__ + "static/media/pluses.1db00113.jpg";